import { parseRuleset } from './rulesetUtils';

// Export/import file format for moving rulesets between environments.
// Exports wrap the ruleset with its identity so an import into another
// environment can create the rule with the same name/type/subtype; a raw
// ruleset JSON file (no wrapper) also imports.

export const buildExportPayload = (businessRule, rulesetRoot) => ({
    name: businessRule.name,
    type: businessRule.type,
    subType: businessRule.subType,
    exportedFrom: window.location.origin,
    exportedAt: new Date().toISOString(),
    json: rulesetRoot ?? businessRule.json,
});

export const downloadExport = (businessRule, rulesetRoot) => {
    const payload = buildExportPayload(businessRule, rulesetRoot);
    const blob = new Blob([JSON.stringify(payload, null, 2)], { type: 'application/json' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `BusinessRule-${String(businessRule.name || 'ruleset').replace(/[^\w.-]+/g, '_')}.json`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
};

// Reads an exported file (wrapper or raw ruleset JSON) and returns
// { meta, rulesetJson, ruleset } — throws with a readable message when the
// content isn't a valid ruleset.
export const readImportFile = async (file) => {
    const text = await file.text();
    let parsed;
    try {
        parsed = JSON.parse(text);
    } catch (error) {
        throw new Error(`the file is not valid JSON (${error.message})`);
    }

    let meta = null;
    let rulesetJson = text;
    const isWrapper = parsed && typeof parsed === 'object' && !Array.isArray(parsed) &&
        parsed.json !== undefined && parsed.name !== undefined;
    if (isWrapper) {
        meta = { name: parsed.name, type: parsed.type, subType: parsed.subType };
        rulesetJson = typeof parsed.json === 'string' ? parsed.json : JSON.stringify(parsed.json, null, 2);
    }

    const ruleset = parseRuleset(rulesetJson);
    return { meta, rulesetJson, ruleset };
};
